import React from 'react'
import PropTypes from 'prop-types'
import { createEvent } from 'ics'
import { saveAs } from 'file-saver'
import isPast from 'date-fns/isPast'
import parseISO from 'date-fns/parseISO'
import formatTime from 'date-fns/format'
import SvgIcon from 'Components/SvgIcon'
import useMobileDetect from 'Hooks/useMobileDetect'
import { _OpenHouse, _Title, _OpenHouseItem, _AddtoCalendar, _Time, _Address, _CloseIcon,
  _Date, _DateTimeContainer, _OpenHouseModalContainer, _Overlay } from './styles'

export const TEST_IDS = {
  OPEN_HOUSE_ITEM: 'openHouseItem',
}

const handleSave = (openHouse, geo, location) => {
  const { date, from, to } = openHouse
  const [year, month, day] = date?.split('-').map(Number)
  const [startHour, startMinute] = from?.split(':').map(Number)
  const [endHour, endMinute] = to?.split(':').map(Number)
  const event = {
    start: [year, month, day, startHour, startMinute],
    end: [year, month, day, endHour, endMinute],
    title: 'Open House',
    description: `Open house for ${location}`,
    location,
    geo: { lat: geo?.[0], lon: geo?.[1] },
    categories: ['Open House', 'Real Estate'],
    status: 'CONFIRMED',
    busyStatus: 'BUSY',
  }

  createEvent(event, (error, value) => {
    const blob = new Blob([value], { type: 'text/calendar;charset=utf8' })
    saveAs(blob, 'open-house-schedule.ics')
  })
}

const OpenHouseItem = ({ openHouse, address, geo, isIos, isMobileApp, googleAnalyticsEvent }) => {
  const date = formatTime(parseISO(openHouse.date), 'EEEE, LLL do')
  const start = formatTime(parseISO(`${openHouse.date} ${openHouse.from}`), 'h:mmaaa')
  const end = formatTime(parseISO(`${openHouse.date} ${openHouse.to}`), 'h:mmaaa')

  return (
    <_OpenHouseItem
      key={date + start}
      isMobileApp={isMobileApp}
      data-test-id={TEST_IDS.OPEN_HOUSE_ITEM}
    >
      <_DateTimeContainer>
        <_Date>{date}</_Date>
        <_Time>{`${start} - ${end}`}</_Time>
      </_DateTimeContainer>
      {(!isIos || !isMobileApp) && (
        <_AddtoCalendar onClick={() => {
          if(isIos && /CriOS/.test(navigator.userAgent)) {
            // eslint-disable-next-line
            window?.alert('Please use Safari to open the calendar. ' +
              'If you\'re using Chrome on your iPhone, copy the link and paste it into Safari.')
            googleAnalyticsEvent({
              category: 'listing',
              action: ['Open House Add to Calendar Click', 'IOS/CHROME'],
            })
          } else {
            handleSave(openHouse, geo, address)
            googleAnalyticsEvent({
              category: 'listing',
              action: ['Open House Add to Calendar Click'],
            })
          }
        }}
        >
          Add to calendar
        </_AddtoCalendar>
      )}
    </_OpenHouseItem>
  )
}
OpenHouseItem.propTypes = {
  openHouse: PropTypes.shape({
    date: PropTypes.string,
    to: PropTypes.string,
    from: PropTypes.string,
  }),
  address: PropTypes.string,
  geo: PropTypes.string,
  isMobileApp: PropTypes.bool,
  isIos: PropTypes.bool,
  googleAnalyticsEvent: PropTypes.func,
}

const OpenHouse = ({ listing, isMobileApp = false, closeModal = () => {}, googleAnalyticsEvent = () => {} }) => {
  const openHouses = listing && listing.open_houses ?
    listing.open_houses.filter(openHouse => !isPast(parseISO(`${openHouse.date} ${openHouse.from}`))) :
    []
  const address = listing?.address?.formatted
  const geo = listing?.address?.coordinates?.coordinates
  const { isIos } = useMobileDetect()
  if(openHouses && !openHouses?.length) return null
  if(isMobileApp) {
    return (
      <>
        <_OpenHouseModalContainer>
          <_OpenHouse isMobileApp>
            <div>
              <_Title>Open House Times</_Title>
              <_Address>{address}</_Address>
              <_CloseIcon onClick={closeModal}>
                <SvgIcon name="#icon-close" width={12} height={12} />
              </_CloseIcon>

            </div>

            {openHouses.map(openHouse => (
              <OpenHouseItem
                key={openHouse.date + openHouse.from}
                openHouse={openHouse}
                address={address}
                geo={geo}
                isIos={isIos}
                isMobileApp={isMobileApp}
                googleAnalyticsEvent={googleAnalyticsEvent}
              />
            ))}

          </_OpenHouse>

        </_OpenHouseModalContainer>
        <_Overlay onClick={closeModal}/>
      </>
    )
  }
  return (
    <_OpenHouse>
      {openHouses.map(openHouse => (
        <OpenHouseItem
          key={openHouse.date + openHouse.from}
          openHouse={openHouse}
          address={address}
          geo={geo}
          isIos={isIos}
          isMobileApp={isMobileApp}
          googleAnalyticsEvent={googleAnalyticsEvent}
        />
      ))}
    </_OpenHouse>
  )
}


OpenHouse.propTypes = {
  listing: PropTypes.shape({
    open_houses: PropTypes.arrayOf(PropTypes.shape({})),
    address: PropTypes.shape({
      formatted: PropTypes.string,
      coordinates: PropTypes.shape({
        coordinates: PropTypes.array,
      }),
    }),
  }),
  isMobileApp: PropTypes.bool,
  closeModal: PropTypes.func,
  googleAnalyticsEvent: PropTypes.func,
}

export default OpenHouse
